import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'
function Currency({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 18 18' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.2667 16.6H4.73333C3.77567 16.6 3 15.8243 3 14.8667V2.73333C3 1.77567 3.77567 1 4.73333
        1H14.2667C15.2243 1 16 1.77567 16 2.73333V14.8667C16 15.8243 15.2243 16.6 14.2667 16.6Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M11.2344 4.89818H12.9677'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M11.2344 7.49974H12.9677'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M6.03125 11.3982H12.9646'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M6.03125 13.9997H12.9646'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M7.33177 4.25052V3.60052'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M7.33177 8.1513V8.8013'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M6.20285 7.68547C6.37098 7.96107 6.65872 8.15173 7.00625 8.15173H7.33125H7.71865C8.22305 8.15173
        8.63125 7.74267 8.63125 7.23913C8.63125 6.82053 8.34612 6.45567 7.94052 6.3534L6.72198 6.04833C6.31638
        5.94607 6.03125 5.5812 6.03125 5.1626C6.03125 4.65907 6.44032 4.25 6.94385 4.25H7.33125H7.65625C8.00292
        4.25 8.28978 4.4398 8.45792 4.71453'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}
Currency.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Currency
